/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import sensor from "../../../Assets/Cartesian/sensor.png";
import MechanicsSummary from "../../../components/Cartesian/MechanicsSummary/MechanicsSummary";
import Button from "../../../components/common/Buttons/Button/Button";
import CustomPopup from "../../../components/common/CustomPopup/CustomPopup";
import MsxIcons from "../../../components/common/Icons/MsxIcons/MsxIcons";
import ToggleInput from "../../../components/common/Inputs/ToggleInput/ToggleInput";
import ProductDataSheetLink from "../../../components/common/Shared/ProductDataSheetLink";
import BundleComparator from "../../../components/Retrofit/Devices/BundleComparator/BundleComparator";
import ComparisonBar from "../../../components/Retrofit/Devices/ComparisonBar";
import CorrespondingCrossComponent from "../../../components/Retrofit/Devices/CorrespondingCrossComponent/CorrespondingCrossComponent";
import FiltersWrapper from "../../../components/Retrofit/Devices/FiltersWrapper";
import { useGetRetrofitBundles } from "../../../components/Retrofit/useGetRetrofitBundles";
import Navigator from "../../../layouts/Navigator/Navigator";
import {
  HOLLOW_SHAFT,
  NO_GEARBOX,
  NO_MOTOR,
  getGearBoxDiabledOptions,
  getGearBoxOrientation,
  getMotorDiabledOptions,
  getMotorGearBoxDefaultOrientation,
  getMotorOrientation,
  getMountingImage,
  getMountingOptions,
  getMountingOptionsSideDefault,
  isSelectBundleDisabled
} from "../../../store/data/cartesianData";
import { choosableColumns, defaultColumns } from "../../../store/data/retrofitData";
import {
  selectAxisOptions,
  selectAxisSelection,
  selectCartesianReadOnlyMode,
  selectCartesianSteps,
  selectSelectedAxis,
  selectSelectedBundle,
  setAxisOptions,
  setBundleChanged,
  setCartesianCurrentStep,
  setCartesianShowReadOnlyDialogPopup,
  setSelectedBundle
} from "../../../store/slices/cartesian";
import { updateConfiguration } from "../../../store/slices/common";
import {
  addNewAxis,
  clearBundlesToCompare,
  selectBundlesToCompare,
  selectCountOfBundles,
  selectCurrentAxisFilters,
  selectCurrentFiltersStepperStep,
  selectDefaultRetrofitConfiguration,
  selectFetchedBundles,
  selectRetrofitConfiguration,
  selectRowsToShow,
  setAxisFilters,
  setConfiguration,
  setCurrentFiltersStepperStep,
  setRowsToShow,
  setShowAxisPopup,
  showSnackbar
} from "../../../store/slices/retrofit";
import { getProductImgUrl, saveConfiguration } from "../../../utils/common/api/api";
import { buildHost } from "../../../utils/common/func.util";
import t from "../../../utils/common/translation/translator";

const SelectBundlePopup = ({ opened, onClose }) => {
  const dispatch = useDispatch();
  const selectedBundle = useSelector(selectSelectedBundle);

  const selectBundle = async (bundle) => {
    dispatch(setSelectedBundle(bundle));
    dispatch(setBundleChanged(true));
    dispatch(setShowAxisPopup(false));
    // clear the compare list
    dispatch(clearBundlesToCompare());
    dispatch(updateConfiguration());
    onClose();
  };

  const bundlesToCompare = useSelector(selectBundlesToCompare);
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);
  const currentFilters = useSelector(selectCurrentAxisFilters);

  // Get fetched (and filtered) bundles from redux
  const fetchedBundles = useSelector(selectFetchedBundles);
  const countOfBundles = useSelector(selectCountOfBundles);

  const rowsToShow = useSelector(selectRowsToShow);
  const [paging, setPaging] = useState({ skip: 0, limit: rowsToShow });

  const [orderBy, setOrderBy] = useState({
    attributeName: "nominalTorque",
    sort: "asc"
  });

  const handleApplyFilters = (axisId, newFilters) => {
    dispatch(setAxisFilters({ axisId, filters: newFilters }));
  };

  const { refetch: fetchRetrofitBundles, isFetching: isFetchingBundles } = useGetRetrofitBundles(
    currentFilters,
    paging,
    orderBy
  );

  return (
    <CustomPopup opened={opened} onClose={onClose} wideWidth data-testid="select-bundle-popup">
      <div className="SelectBundlePopup h-[80vh]">
        {currentFiltersStep === 1 && (
          <>
            <FiltersWrapper filters={currentFilters} onApplyFilters={handleApplyFilters} axisId={1} />
            <CorrespondingCrossComponent
              filters={currentFilters}
              selectedBundle={selectedBundle}
              onSelectBundle={selectBundle}
              defaultColumns={defaultColumns}
              choosableColumns={choosableColumns}
              bundles={fetchedBundles}
              fetchBundles={fetchRetrofitBundles}
              isFetchingBundles={isFetchingBundles}
              paging={paging}
              setPaging={setPaging}
              rowsToShow={rowsToShow}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              countOfBundles={countOfBundles}
            />
          </>
        )}
        {currentFiltersStep === 2 && <BundleComparator onSelectBundle={selectBundle} />}

        {bundlesToCompare?.length > 0 && <ComparisonBar />}
      </div>
    </CustomPopup>
  );
};

const ProductCard = ({
  title,
  imageAlt,
  imageUrl,
  reference,
  description,
  orientationMountingSide,
  mounted,
  onClickMount,
  characteristics
}) => (
  <div className="ProductCard border-[1px] overflow-hidden shadow-sm">
    <span className="bg-gray-400 text-white px-4 text-center rounded-br-3xl block w-24">{title}</span>
    <div className="grid grid-cols-3 gap-4 p-[0.25rem]">
      <div className="col-span-1 flex items-center space-x-5">
        <div>
          {/* the image must be grayed if it's not mounted */}
          <img className={!mounted && "opacity-40"} alt={imageAlt} src={imageUrl} />
        </div>
        <div className="flex flex-col space-y-1">
          <span className={`text-secondary underline font-semibold cursor-pointer text-xs ${!mounted && "hidden"}`}>
            <ProductDataSheetLink reference={reference} />
          </span>
          <span className={`font-semibold text-black ${!mounted && "hidden"}`}>{description}</span>
          {!mounted && (
            <div className="h-9">
              <div className="p-[0.25rem] rounded flex items-center space-x-2 bg-[#42B4E640]">
                <MsxIcons name="info-tooltip" size="nano" className="mt-1" />
                <span>{t("cartesian.ui.axis_options.only_motor_adapter")}</span>
              </div>
            </div>
          )}
          <div className="flex space-x-1 items-center -ml-1">
            <span className="transform scale-75">
              <ToggleInput checked={mounted} switchable onChange={() => onClickMount(reference)} />
            </span>
            <span className="-mt-1">
              {mounted ? t("cartesian.ui.axis_options.mounted") : t("cartesian.ui.axis_options.adapter_only")}
            </span>
          </div>
        </div>
      </div>
      <div className="col-span-2 flex space-x-5 divide-x-2 items-center">
        {orientationMountingSide && (
          <div className={`flex space-x-5 ${!mounted && "opacity-40"}`}>
            <div className="flex flex-col">
              <span className="underline">{t("cartesian.ui.axis_options.orientation")}</span>
              <span className="font-semibold">
                {orientationMountingSide?.orientation === NO_MOTOR ||
                orientationMountingSide?.orientation === NO_GEARBOX
                  ? orientationMountingSide?.orientation
                  : orientationMountingSide?.orientation + "\u00B0"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="underline">{t("cartesian.ui.axis_options.mounting_side")}</span>
              <span className="font-semibold">{orientationMountingSide?.mountingSide}</span>
            </div>
          </div>
        )}
        <div className="flex space-x-5 pl-5">
          {mounted &&
            characteristics?.map((characteristic, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="flex flex-col">
                <span className="underline">{characteristic?.title}</span>
                <span className="font-semibold">{characteristic?.value}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  </div>
);

const AxisSection = () => {
  const dispatch = useDispatch();
  const isReadOnly = useSelector(selectCartesianReadOnlyMode);
  const selectedAxis = useSelector(selectSelectedAxis);
  const selectedBundle = useSelector(selectSelectedBundle);
  const axisOptions = useSelector(selectAxisOptions);
  const defaultRetrofitConfiguration = useSelector(selectDefaultRetrofitConfiguration);
  const [openSelectBundlePopup, setOpenSelectBundlePopup] = useState(false);
  const [mountingOptionsPopupOpened, setMountingOptionsPopupOpened] = useState(false);

  const {
    refetch: createRetrofitConfiguration,
    isLoadingCreateRetrofitConfiguration,
    isFetchingCreateRetrofitConfiguration
  } = useQuery(
    "Save a new retrofit configuration",
    async () => {
      try {
        const savedConf = await saveConfiguration({
          ...defaultRetrofitConfiguration,
          configName: "CARTESIAN SUB CONFIG",
          configStatus: "CARTESIAN_SUB_CONFIG"
          // configStatus: "IN_PROGRESS"
        });

        let host = buildHost();
        const newConfiguration = {
          ...savedConf.savedConfigData,
          configData: {
            ...savedConf.savedConfigData.configData,
            host,
            linkToConf:
              // eslint-disable-next-line prefer-template
              window.location.href +
              (window.location.search ? "&" : "?") +
              "configuration=" +
              savedConf?.savedConfigData?.configId
          }
        };
        dispatch(setConfiguration(newConfiguration));
        dispatch(addNewAxis());
        dispatch(setRowsToShow(10));
        return savedConf;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);

  useEffect(() => {
    if (!retrofitConfiguration) {
      createRetrofitConfiguration();
    }
  }, []);

  const handleClickOnSelectBundle = async () => {
    // console.log("handleClickOnSelectBundle");
    if (isReadOnly) {
      dispatch(setCartesianShowReadOnlyDialogPopup(true));
      return;
    }
    // create a Retrofit configuration if it doesn't exist
    if (!retrofitConfiguration) {
      await createRetrofitConfiguration();
    }
    // set the application data filters for the first axis
    const axisId = 1;
    const currentAppDataFilters = retrofitConfiguration?.configData?.axes?.find((a) => a.id === axisId)?.configFilters
      ?.applicationDataFilter;
    const calculatedAppDataFilters = {
      ...currentAppDataFilters,
      nominalTorque: selectedAxis?.calculations?.driveTorquePreCalculations?.worstDriveTorque,
      nominalSpeed: selectedAxis?.calculations?.totalAxisMovementPreCalculations?.nominalSpeed,
      loadInertia: selectedAxis?.calculations?.totalAxisInertiaPreCalculations.preCalcTotalTranslationalInertia
    };
    const newAppDataFilters = {
      ...calculatedAppDataFilters
    };
    const currentMotorFilters = retrofitConfiguration?.configData?.axes?.find((a) => a.id === axisId)?.configFilters
      ?.motorFilter;
    const newMotorFilters = {
      ...currentMotorFilters,
      withGearbox: selectedAxis?.axis?.driveType === "toothed belt",
      motorType: ["BMH"],
      connectorType: ["Angled"],
      ipDegreeOfProtection: ["IP54"],
      holdingBrake: [false],
      motorEncoder: ["single_turn"]
    };
    const currentDriveFilters = retrofitConfiguration?.configData?.axes?.find((a) => a.id === axisId)?.configFilters
      ?.driveFilter;
    const newDriveFilters = {
      ...currentDriveFilters,
      driveInterface: ["Ethernet/IP"],
      driveVoltages: ["380...480 V", "400 V", "208...480 V"],
      nbPhases: ["3 Phases"],
      driveVoltagesSplitted: [400],
      driveType: ["LXM32"],
      switchingFreq: [8],
      format: ["BOOK"]
    };
    const currentGearboxFilters = retrofitConfiguration?.configData?.axes?.find((a) => a.id === axisId)?.configFilters
      ?.gearboxFilter;
    const newGearboxFilters = {
      ...currentGearboxFilters,
      productOrComponentType: selectedAxis?.axis?.driveType === "toothed belt" ? ["PLANETARY_GEARBOX"] : [],
      externalDiameter: (() => {
        switch (selectedAxis?.axis?.axisSize) {
          case "1":
            return [60];
          case "2":
            return [60];
          case "3":
            return [80];
          case "4":
            return [120];
          default:
            return [];
        }
      })()
    };
    const newFilters = {
      ...retrofitConfiguration?.configData?.axes?.find((a) => a.id === axisId)?.configFilters,
      motorFilter: newMotorFilters,
      driveFilter: newDriveFilters,
      applicationDataFilter: newAppDataFilters,
      gearboxFilter: newGearboxFilters
    };

    dispatch(setAxisFilters({ axisId, filters: newFilters }));
    dispatch(setCurrentFiltersStepperStep(1));
    setOpenSelectBundlePopup(true);
  };

  const handleSetSensor = (sensor) => {
    // console.log("handleSetSensor", sensor);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        sensor
      })
    );
  };

  const handleMotorOrientation = (event) => {
    // console.log("handleMotorOrientation", event);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          ...axisOptions?.mountingOptions,
          motor: { ...axisOptions?.mountingOptions?.motor, orientation: event.target.value }
        }
      })
    );
  };

  const handleGearBoxOrientation = (event) => {
    // console.log("handleGearBoxOrientation", event);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          ...axisOptions?.mountingOptions,
          gearbox: { ...axisOptions?.mountingOptions?.gearbox, orientation: event.target.value }
        }
      })
    );
  };

  const handleMountingOptionsSave = () => {
    // console.log("handleMountingOptionsSave");
    setMountingOptionsPopupOpened(false);
    dispatch(setAxisOptions({ ...axisOptions, isValid: true }));
  };

  const handleMountingOptionsSideClick = (mountingOption) => {
    // console.log("handleMountingOptionsSideClick", mountingOption);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          ...axisOptions?.mountingOptions,
          gearbox: {
            ...axisOptions?.mountingOptions?.gearbox,
            mountingSide: mountingOption
          },
          motor: {
            ...axisOptions?.mountingOptions?.motor,
            mountingSide: mountingOption
          }
        }
      })
    );
  };

  const handleGearBoxMountingClick = (gearBoxMounted) => {
    // console.log("handleGearBoxMountingClick", gearBoxMounted);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          ...axisOptions?.mountingOptions,
          gearbox: {
            ...axisOptions?.mountingOptions?.gearbox,
            mounted: gearBoxMounted
          }
        }
      })
    );
  };

  const handleMotorMountingClick = (motorMounted) => {
    // console.log("handleMotorMountingClick", motorMounted);
    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          ...axisOptions?.mountingOptions,
          motor: {
            ...axisOptions?.mountingOptions?.motor,
            mounted: motorMounted
          }
        }
      })
    );
  };

  useEffect(() => {
    if (isReadOnly) {
      return;
    }
    // mountingOptions calculation
    const mountingSide = getMountingOptions(
      selectedAxis?.axis?.axisGCR,
      axisOptions?.selectedBundle?.bundleData?.motor,
      axisOptions?.selectedBundle?.bundleData?.gearbox,
      !!axisOptions?.selectedBundle?.bundleData?.motor,
      !!axisOptions?.selectedBundle?.bundleData?.gearbox
    );
    const [defaultmotorOrientation, defaultgearBoxOrientation] = getMotorGearBoxDefaultOrientation(
      selectedAxis?.axis?.axisGCR,
      axisOptions?.selectedBundle?.bundleData?.motor,
      axisOptions?.selectedBundle?.bundleData?.gearbox,
      !!axisOptions?.selectedBundle?.bundleData?.motor,
      !!axisOptions?.selectedBundle?.bundleData?.gearbox,
      mountingSide?.[0],
      axisOptions?.selectedBundle?.bundleData?.gearbox?.productOrComponentType
    );

    // console.log("mountingSide", mountingSide);
    // console.log("defaultmotorOrientation", defaultmotorOrientation);
    // console.log("defaultgearBoxOrientation", defaultgearBoxOrientation);

    dispatch(
      setAxisOptions({
        ...axisOptions,
        mountingOptions: {
          gearbox: {
            orientation: axisOptions?.selectedBundle?.bundleData?.gearbox ? defaultgearBoxOrientation : NO_GEARBOX,
            mountingSide: mountingSide?.[0],
            mounted: !!axisOptions?.selectedBundle?.bundleData?.gearbox
          },
          motor: {
            orientation: defaultmotorOrientation,
            mountingSide: mountingSide?.[0],
            mounted: !!axisOptions?.selectedBundle?.bundleData?.motor
          },
          drive: {
            addedToBOM: true
          }
        },
        isValid: axisOptions?.selectedBundle != null ? false : true
      })
    );
  }, [axisOptions?.selectedBundle]);

  return (
    <div className="AxisSection mt-20 flex flex-col space-y-5 w-full">
      <div className="bg-gray-10 shadow border-[1px] border-gray-50 w-full p-3 text-gray-600 text-sm flex flex-col space-y-2">
        <div className="flex flex-col space-y-2">
          <div className="flex items-center space-x-2">
            <span className="text-primary">{t("cartesian.ui.axis_options.axis")}</span>
            <div className="flex-1 flex mt-2">
              <div className="h-[0.5px] w-full bg-gray-300" />
              <div className="w-[0.5px] h-2 bg-gray-300" />
            </div>
          </div>
          <div className="flex space-x-8 px-4 py-1 text-xs">
            <div className="flex space-x-4 flex-1">
              <img src={getProductImgUrl(selectedAxis?.axis?.axisGCR)} alt="Axis" />
              <div className="flex flex-col space-y-3">
                <div className="space-y-2">
                  <span className="text-secondary font-semibold">{selectedAxis?.product}</span>
                  <div className="flex divide-x-2">
                    <span className="pr-2">
                      {t("cartesian.ui.axis_selection.profile_size")}
                      <span className="font-semibold">
                        {": "}
                        {selectedAxis?.axis?.profileDimension ? selectedAxis?.axis?.profileDimension : "-"}
                      </span>
                    </span>
                    <span className="px-2">
                      {t("msizer.ui.drive_filters.drive_type")}
                      <span className="font-semibold">
                        {": "}
                        {selectedAxis?.axis?.driveType ? selectedAxis?.axis?.driveType : "-"}
                      </span>
                    </span>
                    <span className="px-2">
                      {t("cartesian.ui.axis_selection.guide_type")}
                      <span className="font-semibold">
                        {": "}
                        {selectedAxis?.guideType?.guideType ? selectedAxis?.guideType?.guideType : "-"}
                      </span>
                    </span>
                    <span className="px-2">
                      {t("cartesian.ui.axis_selection.feed")}
                      <span className="font-semibold">
                        {": "}
                        {selectedAxis?.axis?.feedConstant ? selectedAxis?.axis?.feedConstant : "-"}
                      </span>
                    </span>
                    <span className="px-2">
                      {t("cartesian.ui.axis_selection.repeatability")}
                      <span className="font-semibold">
                        {": "}
                        {selectedAxis?.axis?.repeatability ? selectedAxis?.axis?.repeatability : "-"}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-5">
                  <div className="flex items-center space-x-1">
                    <span className="transform scale-75">
                      <ToggleInput
                        checked={axisOptions?.pnpSensor}
                        switchable
                        onChange={(e) => {
                          dispatch(
                            setAxisOptions({
                              ...axisOptions,
                              pnpSensor: e,
                              sensorConnected: axisOptions?.sensorConnected ? false : axisOptions?.sensorConnected
                            })
                          );
                        }}
                      />
                    </span>
                    <span className="-mt-1">{t("cartesian.ui.axis_options.pnp_sensor")}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <input
                      className="-mt-1"
                      type="checkbox"
                      checked={axisOptions?.sensorConnected}
                      onChange={(e) => {
                        dispatch(
                          setAxisOptions({
                            ...axisOptions,
                            sensorConnected: e.target.checked
                          })
                        );
                      }}
                      disabled={!axisOptions?.pnpSensor}
                    />
                    <span className={`-mt-1 ${!axisOptions?.pnpSensor ? "text-gray-400" : ""}`}>
                      {t("cartesian.ui.axis_options.connected_sensor")}
                    </span>
                    <div data-tip className="cursor-pointer flex" tabIndex={-1}>
                      <MsxIcons
                        name="info-tooltip"
                        size="nano"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      />
                      <ReactTooltip
                        place="bottom"
                        effect="solid"
                        backgroundColor="#FFFFFF"
                        textColor="rgb(31 41 55)"
                        className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                      >
                        <div className="text-blue-500 font-semibold">
                          {t("cartesian.ui.axis_options.connected_pnp_sensors")}
                        </div>
                        <div className="flex flex-row">
                          <div className="flex-col mr-1 content-center">
                            <img src={sensor} alt="linearAxis" className="max-h-[150px] max-w-[150px] w-35 h-35" />
                          </div>
                          <div className="flex flex-col mt-2">
                            <div className="w-64">{t("cartesian.ui.axis_options.connected_sensor_tooltip")}</div>
                          </div>
                        </div>
                      </ReactTooltip>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1">
                    <span className={`-mt-1 ${!axisOptions?.pnpSensor ? "text-gray-400" : ""}`}>
                      {t("msizer.ui.quantity")}
                    </span>
                    {Array.from({ length: 4 }, (_, i) => i + 1).map((index) => (
                      <span
                        disabled={!axisOptions?.pnpSensor}
                        key={index}
                        onClick={() => {
                          if (axisOptions?.pnpSensor) handleSetSensor(index);
                        }}
                        className={`h-6 w-10 flex items-center justify-center border-[1px] shadow-sm border-gray-300 ${
                          index === axisOptions.sensor
                            ? axisOptions?.pnpSensor
                              ? "bg-secondary border-transparent text-white"
                              : "bg-white"
                            : axisOptions?.pnpSensor
                            ? "bg-white hover:bg-secondary hover:text-white"
                            : "bg-white"
                        }
                        ${!axisOptions?.pnpSensor ? "text-gray-400" : "cursor-pointer transition-all duration-100"}`}
                      >
                        {index}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-3 shadow-[inset_0_0px_4px_rgba(0,0,0,0.25)] border-[1px] border-gray-50 flex flex-col space-y-2">
          {!selectedBundle && (
            <div>
              <span className="mb-1">{t("cartesian.ui.axis_options.select_motor_gearbox_for_axis")}</span>
              <div className="border-[1px] border-gray-100 p-5 flex flex-col space-y-2 items-center justify-center">
                <span className="text-gray-400">
                  {isSelectBundleDisabled(selectedAxis?.axis?.axisGCR)
                    ? "Support Axis is selected"
                    : t("cartesian.ui.axis_options.hollow_shaft")}
                </span>
                <Button
                  onClick={handleClickOnSelectBundle}
                  primary
                  large
                  disabled={
                    isLoadingCreateRetrofitConfiguration ||
                    isFetchingCreateRetrofitConfiguration ||
                    isSelectBundleDisabled(selectedAxis?.axis?.axisGCR)
                  }
                >
                  {isLoadingCreateRetrofitConfiguration || isFetchingCreateRetrofitConfiguration
                    ? t("cartesian.ui.axis_options.loading")
                    : t("cartesian.ui.axis_options.select_bundle")}
                </Button>
              </div>
            </div>
          )}
          {selectedBundle && (
            <div className="flex flex-col text-xs space-y-4">
              <div className="flex justify-between">
                <div className="flex flex-col">
                  <Button
                    primary
                    small
                    classes={!axisOptions?.isValid ? "border-[1px] border-red-600" : ""}
                    onClick={() => {
                      setMountingOptionsPopupOpened(true);
                    }}
                  >
                    <span className="px-5">{t("cartesian.ui.axis_options.mounting_options")} </span>
                  </Button>
                  {!axisOptions?.isValid && (
                    <div>
                      <MsxIcons name="alert" size="nano" />
                      <span className="text-red-600">{t("msizer.ui.mandatory_field_missing")}</span>
                    </div>
                  )}
                </div>
                <div className="flex items-center space-x-2">
                  <Button secondary small onClick={handleClickOnSelectBundle}>
                    <span>{t("msizer.ui.select.change_product_bundle_button_text")}</span>
                  </Button>
                  <Button
                    onClick={() => {
                      dispatch(setSelectedBundle(null));
                    }}
                  >
                    <MsxIcons name="action_delete" />
                  </Button>
                </div>
              </div>

              {selectedBundle?.gearboxReference && (
                <ProductCard
                  data-testid="product-card-gearbox"
                  title={t("msizer.ui.gearbox")}
                  imageAlt={selectedBundle?.gearboxReference}
                  imageUrl={getProductImgUrl(selectedBundle?.gearboxReference, 50, 50)}
                  reference={selectedBundle?.gearboxReference}
                  description={t("cartesian.ui.axis_options.gear_mounted_on_axis")}
                  orientationMountingSide={{
                    orientation: axisOptions?.mountingOptions?.gearbox?.orientation,
                    mountingSide: axisOptions?.mountingOptions?.gearbox?.mountingSide
                  }}
                  mounted={axisOptions.mountingOptions?.gearbox?.mounted}
                  onClickMount={() => {
                    handleGearBoxMountingClick(!axisOptions.mountingOptions?.gearbox?.mounted);
                  }}
                  characteristics={[
                    {
                      title: t("msizer.ui.type"),
                      value: selectedBundle?.bundleData?.gearbox?.productOrComponentType
                    },
                    {
                      title: t("cartesian.ui.axis_options.ratio"),
                      value: `${selectedBundle?.bundleData?.gearbox?.reductionRatio}:1`
                    },
                    {
                      title: t("msizer.ui.gearbox_filters.external_diameter"),
                      value: selectedBundle?.bundleData?.gearbox?.externalDiameter
                    }
                  ]}
                />
              )}

              <ProductCard
                data-testid="product-card-motor"
                title={t("cartesian.ui.axis_options.motor")}
                imageAlt={selectedBundle?.motorReference}
                imageUrl={getProductImgUrl(selectedBundle?.motorReference, 50, 50)}
                reference={selectedBundle?.motorReference}
                description={t("cartesian.ui.axis_options.motor_mounted_on_axis")}
                orientationMountingSide={{
                  orientation: axisOptions?.mountingOptions?.motor?.orientation,
                  mountingSide: axisOptions?.mountingOptions?.motor?.mountingSide
                }}
                mounted={axisOptions.mountingOptions?.motor?.mounted}
                onClickMount={() => {
                  handleMotorMountingClick(!axisOptions.mountingOptions?.motor?.mounted);
                }}
                characteristics={[
                  {
                    title: t("cartesian.ui.axis_options.nominal_torque"),
                    value: selectedBundle?.bundleData?.nominalTorqueOfMotor
                  },
                  {
                    title: t("cartesian.ui.axis_options.nominal_speed"),
                    value: selectedBundle?.bundleData?.nominalSpeedOfMotor
                  },
                  {
                    title: t("cartesian.ui.axis_options.inertia"),
                    value: selectedBundle?.bundleData?.motor?.inertiaMotor
                  }
                ]}
              />
            </div>
          )}
        </div>
        <SelectBundlePopup opened={openSelectBundlePopup} onClose={() => setOpenSelectBundlePopup(false)} />
      </div>
      {selectedBundle && (
        <div
          className={`bg-gray-10 shadow border-[1px] border-gray-50 w-full p-3 text-gray-600 text-sm
        ${!axisOptions?.mountingOptions?.drive?.addedToBOM && "opacity-40"}`}
        >
          <div className="flex items-center space-x-2">
            <span className="text-primary">{t("cartesian.ui.accessories.drive")}</span>
            <div className="flex-1 flex mt-2">
              <div className="h-[0.5px] w-full bg-gray-300" />
              <div className="w-[0.5px] h-2 bg-gray-300" />
            </div>
          </div>
          <div className="flex items-center space-x-5 p-[0.25rem]">
            <div>
              <img
                className=""
                alt={selectedBundle?.driveReference}
                src={getProductImgUrl(selectedBundle?.driveReference, 50, 50)}
              />
            </div>
            <div className="flex flex-col space-y-1">
              <span className="text-secondary underline font-semibold cursor-pointer text-xs">
                <ProductDataSheetLink reference={selectedBundle?.driveReference} />
              </span>
              <div className="flex items-center space-x-3 divide-x-2">
                <div>
                  <span>{t("cartesian.ui.accessories.supply_voltage")}:</span>
                  <span className="font-semibold ml-1">{selectedBundle?.bundleData?.supplyVoltage}V</span>
                </div>
                <div className="pl-3">
                  <span>{t("cartesian.ui.accessories.output_current")}:</span>
                  <span className="font-semibold ml-1">
                    {selectedBundle?.bundleData?.drive?.outputCurrents?.toString()}
                  </span>
                </div>
              </div>
              <div className="flex space-x-1 items-center -ml-1 opacity-100">
                <span className="transform scale-75">
                  <ToggleInput
                    checked={axisOptions?.mountingOptions?.drive?.addedToBOM}
                    onChange={(checked) => {
                      dispatch(
                        setAxisOptions({
                          ...axisOptions,
                          mountingOptions: {
                            ...axisOptions?.mountingOptions,
                            drive: {
                              ...axisOptions?.mountingOptions?.drive,
                              addedToBOM: checked
                            }
                          }
                        })
                      );
                    }}
                    switchable
                  />
                </span>
                <span className="-mt-1">
                  {axisOptions?.mountingOptions?.drive?.addedToBOM
                    ? t("cartesian.ui.accessories.added_to_the_bill_of_material")
                    : t("cartesian.ui.accessories.not_added_to_the_bill_of_material")}
                </span>
              </div>
            </div>
            <div className="flex flex-1 justify-end">
              {axisOptions?.mountingOptions?.drive?.addedToBOM && (
                <Button
                  secondary
                  small
                  onClick={() => {
                    setOpenSelectBundlePopup(true);
                  }}
                >
                  <span>{t("msizer.ui.select.change_product_bundle_button_text")}</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
      <CustomPopup
        maxWidth="650px"
        opened={mountingOptionsPopupOpened}
        headerTitle={t("cartesian.ui.axis_options.mounting_options")}
        data-testid="mounting-options-popup"
      >
        <div className="MountingOptionsPopup flex items-center space-x-10 mt-5">
          <img
            className="w-40"
            src={getMountingImage(axisOptions.mountingOptions?.motor?.mountingSide)}
            alt="orientation"
          />
          <div className="flex space-x-3">
            <div className="flex-1 flex flex-col">
              <span className="mb-2 font-semibold">{t("cartesian.ui.axis_options.mounting_side")}</span>
              {getMountingOptionsSideDefault().map((mountingOption) => (
                <Button
                  primary={
                    axisOptions.mountingOptions?.motor?.mountingSide?.toLowerCase() === mountingOption?.toLowerCase()
                  }
                  secondary={mountingOption}
                  onClick={() => handleMountingOptionsSideClick(mountingOption)}
                >
                  <span className="w-full text-center">{mountingOption}</span>
                </Button>
              ))}
            </div>
            <div className="flex-1">
              <span className="mb-2 font-semibold">{t("cartesian.ui.axis_options.motor_orientation")}</span>
              <div className="flex flex-col space-y-2 items-start ml-2 mt-2">
                {getMotorOrientation().map((degree) => {
                  const isMotorDegreeDisabled = getMotorDiabledOptions().includes(degree);
                  return (
                    <label
                      key={degree}
                      className={`flex items-center space-x-2 cursor-pointer ${
                        isMotorDegreeDisabled ? "text-gray-300" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="motorOrientation"
                        className="checked:bg-primary checked:border-transparent"
                        value={degree}
                        checked={axisOptions.mountingOptions?.motor?.orientation === degree}
                        onChange={handleMotorOrientation}
                        disabled={isMotorDegreeDisabled}
                      />
                      <span>{degree === NO_MOTOR ? degree : degree + "\u00B0"}</span>
                    </label>
                  );
                })}
              </div>
            </div>
            <div className="flex-1">
              <span className="mb-2 font-semibold">{t("cartesian.ui.axis_options.gearbox_orientation")}</span>
              <div className="flex flex-col space-y-2 items-start ml-2 mt-2">
                {getGearBoxOrientation().map((degree) => {
                  const isGearBoxDegreeDisabled = getGearBoxDiabledOptions().includes(degree);
                  return (
                    <label
                      key={degree}
                      className={`flex items-center space-x-2 cursor-pointer ${
                        isGearBoxDegreeDisabled ? "text-gray-300" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="gearboxOrientation"
                        className="checked:bg-primary checked:border-transparent"
                        value={degree}
                        checked={axisOptions.mountingOptions?.gearbox?.orientation === degree}
                        onChange={handleGearBoxOrientation}
                        disabled={isGearBoxDegreeDisabled}
                      />
                      <span>{degree === NO_GEARBOX ? degree : degree + "\u00B0"}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <Button primary classes="m-auto mt-10" large onClick={handleMountingOptionsSave}>
          <span className="px-5">{t("cartesian.ui.axis_options.save")}</span>
        </Button>
      </CustomPopup>
    </div>
  );
};

const AxisOptions = () => {
  const dispatch = useDispatch();
  const steps = useSelector(selectCartesianSteps);
  const axisOptions = useSelector(selectAxisOptions);

  const handleContinue = () => {
    if (axisOptions?.isValid) {
      dispatch(setAxisOptions({ ...axisOptions, isValid: axisOptions?.selectedBundle !== null }));
      dispatch(setCartesianCurrentStep(steps.FINALIZE_CARTESIAN));
      dispatch(updateConfiguration());
      dispatch(setBundleChanged(null));
    } else {
      dispatch(
        showSnackbar({
          id: "MISSING_OR_INCORRECT_FIELD",
          customMessage: `: ${t("cartesian.ui.axis_options.mountingoption.verify.meesage")}`
        })
      );
    }
  };

  const handlePrevious = () => {
    dispatch(setCartesianCurrentStep(steps.AXIS_SELECTION));
    dispatch(updateConfiguration());
  };

  return (
    <div className="AxisOptions">
      <MechanicsSummary data-testid="mechanics-summary" />
      <div className="flex">
        <AxisSection data-testid="axis-section" />
      </div>
      <Navigator
        continueLabel={t("msizer.ui.footer.continue")}
        continueAction={() => {
          handleContinue();
        }}
        continueButtonDisabled={!axisOptions?.isValid}
        previousAction={() => {
          handlePrevious();
        }}
      />
    </div>
  );
};

export default AxisOptions;
